export default "skymp5-front/2d9e5859690f430375dd5e413121918d.png";